import Axios from 'axios'
import { getPathName, getApiHash, getApiToken } from './helper';

const obtenerMarcas = async (rubro = "Auto") => {
    const params = {
        hash: await getApiHash(),
        marca: "",
        rubro
    }
    const headers = { 
        'content-type': 'application/json',
        "Authorization" : 'Bearer ' + await getApiToken()
    }
    return await Axios.post(await getPathName() + "/getmarcasjson", params,
        {
            headers: headers
        }).then(function (response) {
            return response?.data?.marcas;
        }).catch(function (error) {
            return error;
    });
};

export default obtenerMarcas;